import { render, staticRenderFns } from "./index-办公区道闸.vue?vue&type=template&id=0251ca62&scoped=true&"
import script from "./index-办公区道闸.vue?vue&type=script&lang=js&"
export * from "./index-办公区道闸.vue?vue&type=script&lang=js&"
import style0 from "./index-办公区道闸.vue?vue&type=style&index=0&id=0251ca62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0251ca62",
  null
  
)

export default component.exports